module.exports = __webpack_public_path__ + "img/hongshu.2313c848.jpg";